import 'babel-polyfill';
import 'modernizr';
import 'normalize.css';

// import copy
import copy from '../copy/copy.json';

// render incompatible browser screen
import Incompatible from './utilities/Incompatible';
import incompatibleTemplate from './views/incompatible/incompatible.html';
import incompatibleStyle from './views/incompatible/incompatible.scss';


Incompatible.addClass();
Incompatible.render(incompatibleTemplate, incompatibleStyle, copy.incompatible);

// render build version
import Version from './utilities/Version';
import versionTemplate from './views/version/version.html';
import versionStyle from './views/version/version.scss';

Version.logConsole();
Version.render(versionTemplate, versionStyle, Version.getCopy());

// render loader
import Loader from './utilities/Loader';
import loaderTemplate from './views/loader/loader.html';
import loaderStyle from './views/loader/loader.scss';

// set loader callbacks
function _progress(e) {
    let p = Math.round(100 * e.progress);

    // render progress in loader
    Loader.render(loaderTemplate, loaderStyle, { loader: p + copy.loader.progress });
}

// import angular and app
import angular from 'angular';
import app from '../app/app';

function _complete() {
    /**
     * Init Jquery as Global
     */
    window.$ = window.jQuery = require("jquery");

    // create new chunk
    require.ensure([], require => {
        let injector = angular.injector(['ng']);

        let url = 'https://api.contentful.com/spaces/erjaey3bjggb/content_types?order=name';
        let config = {
            headers: {
                'Authorization': 'Bearer ef7b0d42ac9b1ca71be8137f1c406c6c489d2678ff16135ddea89f75561d3cc1'
            }
        };

        /***
         * Call the content_type API by Contentful to getting all information on content types.
         */

        function getParameterByName(name, url) {
            if (!url) url = window.location.href;
            name = name.replace(/[\[\]]/g, "\\$&");
            var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
                results = regex.exec(url);
            if (!results) return null;
            if (!results[2]) return '';
            return decodeURIComponent(results[2].replace(/\+/g, " "));
        }

        function getCookie(cname) {
            var name = cname + "=";
            var decodedCookie = decodeURIComponent(document.cookie);
            var ca = decodedCookie.split(';');
            for(var i = 0; i <ca.length; i++) {
                var c = ca[i];
                while (c.charAt(0) == ' ') {
                    c = c.substring(1);
                }
                if (c.indexOf(name) == 0) {
                    return c.substring(name.length, c.length);
                }
            }
            return "";
        }

        function setCookie(cname, cvalue) {
            document.cookie = cname + "=" + cvalue;
        }

        function boostrapApp ($http, $window) {
            let contentTypes = [
                {
                    "sys": {
                        "space": {
                            "sys": {
                                "type": "Link",
                                "linkType": "Space",
                                "id": "erjaey3bjggb"
                            }
                        },
                        "id": "article",
                        "type": "ContentType",
                        "createdAt": "2016-11-28T19:35:14.315Z",
                        "updatedAt": "2017-11-15T11:25:51.994Z",
                        "createdBy": {
                            "sys": {
                                "type": "Link",
                                "linkType": "User",
                                "id": "603S8UAs0eYqI5l8euNs93"
                            }
                        },
                        "updatedBy": {
                            "sys": {
                                "type": "Link",
                                "linkType": "User",
                                "id": "501QXvDXXucWeaBsrSuV0O"
                            }
                        },
                        "publishedCounter": 48,
                        "version": 149,
                        "publishedBy": {
                            "sys": {
                                "type": "Link",
                                "linkType": "User",
                                "id": "501QXvDXXucWeaBsrSuV0O"
                            }
                        },
                        "publishedVersion": 148,
                        "firstPublishedAt": "2016-11-28T19:35:14.675Z",
                        "publishedAt": "2017-11-15T11:25:51.994Z"
                    },
                    "displayField": "title",
                    "name": "Article",
                    "description": "",
                    "fields": [
                        {
                            "id": "pageTitle",
                            "name": "Teaser",
                            "type": "Symbol",
                            "localized": false,
                            "required": false,
                            "validations": [],
                            "disabled": false,
                            "omitted": false
                        },
                        {
                            "id": "layout",
                            "name": "Layout",
                            "type": "Symbol",
                            "localized": false,
                            "required": false,
                            "validations": [
                                {
                                    "in": [
                                        "text",
                                        "table"
                                    ]
                                }
                            ],
                            "disabled": false,
                            "omitted": false
                        },
                        {
                            "id": "title",
                            "name": "Überschrift",
                            "type": "Symbol",
                            "localized": false,
                            "required": false,
                            "validations": [
                                {
                                    "size": {
                                        "min": 2,
                                        "max": 80
                                    }
                                }
                            ],
                            "disabled": false,
                            "omitted": false
                        },
                        {
                            "id": "subtitle",
                            "name": "Untertitel",
                            "type": "Symbol",
                            "localized": false,
                            "required": false,
                            "validations": [],
                            "disabled": true,
                            "omitted": false
                        },
                        {
                            "id": "images",
                            "name": "Bilder",
                            "type": "Array",
                            "localized": false,
                            "required": false,
                            "validations": [],
                            "disabled": false,
                            "omitted": false,
                            "items": {
                                "type": "Link",
                                "validations": [
                                    {
                                        "linkMimetypeGroup": [
                                            "image"
                                        ]
                                    }
                                ],
                                "linkType": "Asset"
                            }
                        },
                        {
                            "id": "image",
                            "name": "Image",
                            "type": "Link",
                            "localized": false,
                            "required": false,
                            "validations": [],
                            "disabled": true,
                            "omitted": true,
                            "linkType": "Asset"
                        },
                        {
                            "id": "text",
                            "name": "Text",
                            "type": "Text",
                            "localized": false,
                            "required": false,
                            "validations": [],
                            "disabled": false,
                            "omitted": false
                        },
                        {
                            "id": "keywords",
                            "name": "Schlagwörter",
                            "type": "Array",
                            "localized": false,
                            "required": false,
                            "validations": [],
                            "disabled": false,
                            "omitted": false,
                            "items": {
                                "type": "Symbol",
                                "validations": []
                            }
                        },
                        {
                            "id": "region",
                            "name": "Region",
                            "type": "Link",
                            "localized": false,
                            "required": false,
                            "validations": [
                                {
                                    "linkContentType": [
                                        "region"
                                    ]
                                }
                            ],
                            "disabled": false,
                            "omitted": false,
                            "linkType": "Entry"
                        },
                        {
                            "id": "hidden",
                            "name": "hidden",
                            "type": "Boolean",
                            "localized": false,
                            "required": false,
                            "validations": [],
                            "disabled": false,
                            "omitted": false
                        },
                        {
                            "id": "createdBy",
                            "name": "Created By",
                            "type": "Symbol",
                            "localized": false,
                            "required": false,
                            "validations": [],
                            "disabled": true,
                            "omitted": false
                        },
                        {
                            "id": "updateBy",
                            "name": "Update By",
                            "type": "Symbol",
                            "localized": false,
                            "required": false,
                            "validations": [],
                            "disabled": true,
                            "omitted": false
                        },
                        {
                            "id": "legacyId",
                            "name": "Legacy id",
                            "type": "Integer",
                            "localized": false,
                            "required": false,
                            "validations": [
                                {
                                    "unique": true
                                }
                            ],
                            "disabled": true,
                            "omitted": false
                        },
                        {
                            "id": "activeFrom",
                            "name": "Active from",
                            "type": "Date",
                            "localized": false,
                            "required": false,
                            "validations": [],
                            "disabled": false,
                            "omitted": false
                        },
                        {
                            "id": "activeTo",
                            "name": "Active to",
                            "type": "Date",
                            "localized": false,
                            "required": false,
                            "validations": [],
                            "disabled": false,
                            "omitted": false
                        },
                        {
                            "id": "authorId",
                            "name": "Author ID",
                            "type": "Symbol",
                            "localized": false,
                            "required": false,
                            "validations": [],
                            "disabled": false,
                            "omitted": false
                        },
                        {
                            "id": "authorName",
                            "name": "Author Name",
                            "type": "Symbol",
                            "localized": false,
                            "required": false,
                            "validations": [],
                            "disabled": false,
                            "omitted": false
                        }
                    ]
                },
                {
                    "sys": {
                        "space": {
                            "sys": {
                                "type": "Link",
                                "linkType": "Space",
                                "id": "erjaey3bjggb"
                            }
                        },
                        "id": "club",
                        "type": "ContentType",
                        "createdAt": "2017-10-25T13:53:23.001Z",
                        "updatedAt": "2017-11-16T14:26:23.952Z",
                        "createdBy": {
                            "sys": {
                                "type": "Link",
                                "linkType": "User",
                                "id": "603S8UAs0eYqI5l8euNs93"
                            }
                        },
                        "updatedBy": {
                            "sys": {
                                "type": "Link",
                                "linkType": "User",
                                "id": "603S8UAs0eYqI5l8euNs93"
                            }
                        },
                        "publishedCounter": 4,
                        "version": 8,
                        "publishedBy": {
                            "sys": {
                                "type": "Link",
                                "linkType": "User",
                                "id": "603S8UAs0eYqI5l8euNs93"
                            }
                        },
                        "publishedVersion": 7,
                        "firstPublishedAt": "2017-10-25T13:53:23.606Z",
                        "publishedAt": "2017-11-16T14:26:23.952Z"
                    },
                    "displayField": "title",
                    "name": "Club",
                    "description": "",
                    "fields": [
                        {
                            "id": "title",
                            "name": "Title",
                            "type": "Symbol",
                            "localized": false,
                            "required": true,
                            "validations": [],
                            "disabled": false,
                            "omitted": false
                        },
                        {
                            "id": "clubNumber",
                            "name": "Club Number",
                            "type": "Symbol",
                            "localized": false,
                            "required": true,
                            "validations": [],
                            "disabled": false,
                            "omitted": false
                        },
                        {
                            "id": "contact",
                            "name": "Contact",
                            "type": "Symbol",
                            "localized": false,
                            "required": true,
                            "validations": [],
                            "disabled": false,
                            "omitted": false
                        },
                        {
                            "id": "comment",
                            "name": "Comment",
                            "type": "Text",
                            "localized": false,
                            "required": false,
                            "validations": [],
                            "disabled": false,
                            "omitted": false
                        }
                    ]
                },
                {
                    "sys": {
                        "space": {
                            "sys": {
                                "type": "Link",
                                "linkType": "Space",
                                "id": "erjaey3bjggb"
                            }
                        },
                        "id": "navigation",
                        "type": "ContentType",
                        "createdAt": "2016-11-28T19:32:47.113Z",
                        "updatedAt": "2017-09-04T12:40:40.439Z",
                        "createdBy": {
                            "sys": {
                                "type": "Link",
                                "linkType": "User",
                                "id": "603S8UAs0eYqI5l8euNs93"
                            }
                        },
                        "updatedBy": {
                            "sys": {
                                "type": "Link",
                                "linkType": "User",
                                "id": "501QXvDXXucWeaBsrSuV0O"
                            }
                        },
                        "publishedCounter": 6,
                        "version": 14,
                        "publishedBy": {
                            "sys": {
                                "type": "Link",
                                "linkType": "User",
                                "id": "501QXvDXXucWeaBsrSuV0O"
                            }
                        },
                        "publishedVersion": 13,
                        "firstPublishedAt": "2016-11-28T19:32:47.515Z",
                        "publishedAt": "2017-09-04T12:40:40.439Z"
                    },
                    "displayField": "title",
                    "name": "Navigation",
                    "description": "",
                    "fields": [
                        {
                            "id": "title",
                            "name": "Title",
                            "type": "Symbol",
                            "localized": false,
                            "required": true,
                            "validations": [
                                {
                                    "unique": true
                                }
                            ],
                            "disabled": false,
                            "omitted": false
                        },
                        {
                            "id": "navigationItems",
                            "name": "Navigation Items",
                            "type": "Array",
                            "localized": false,
                            "required": false,
                            "validations": [],
                            "disabled": false,
                            "omitted": false,
                            "items": {
                                "type": "Link",
                                "validations": [
                                    {
                                        "linkContentType": [
                                            "navigationItem"
                                        ]
                                    }
                                ],
                                "linkType": "Entry"
                            }
                        },
                        {
                            "id": "region",
                            "name": "Region",
                            "type": "Link",
                            "localized": false,
                            "required": true,
                            "validations": [
                                {
                                    "linkContentType": [
                                        "region"
                                    ],
                                    "message": "Must be a region"
                                }
                            ],
                            "disabled": false,
                            "omitted": false,
                            "linkType": "Entry"
                        },
                        {
                            "id": "orders",
                            "name": "orders",
                            "type": "Array",
                            "localized": false,
                            "required": false,
                            "validations": [],
                            "disabled": true,
                            "omitted": false,
                            "items": {
                                "type": "Symbol",
                                "validations": []
                            }
                        }
                    ]
                },
                {
                    "sys": {
                        "space": {
                            "sys": {
                                "type": "Link",
                                "linkType": "Space",
                                "id": "erjaey3bjggb"
                            }
                        },
                        "id": "navigationItem",
                        "type": "ContentType",
                        "createdAt": "2016-11-28T19:33:26.015Z",
                        "updatedAt": "2017-09-14T04:10:27.133Z",
                        "createdBy": {
                            "sys": {
                                "type": "Link",
                                "linkType": "User",
                                "id": "603S8UAs0eYqI5l8euNs93"
                            }
                        },
                        "updatedBy": {
                            "sys": {
                                "type": "Link",
                                "linkType": "User",
                                "id": "603S8UAs0eYqI5l8euNs93"
                            }
                        },
                        "publishedCounter": 9,
                        "version": 18,
                        "publishedBy": {
                            "sys": {
                                "type": "Link",
                                "linkType": "User",
                                "id": "603S8UAs0eYqI5l8euNs93"
                            }
                        },
                        "publishedVersion": 17,
                        "firstPublishedAt": "2016-11-28T19:33:26.402Z",
                        "publishedAt": "2017-09-14T04:10:27.133Z"
                    },
                    "displayField": "title",
                    "name": "Navigation Item",
                    "description": "",
                    "fields": [
                        {
                            "id": "title",
                            "name": "Title",
                            "type": "Symbol",
                            "localized": false,
                            "required": false,
                            "validations": [],
                            "disabled": false,
                            "omitted": false
                        },
                        {
                            "id": "navigationItems",
                            "name": "Navigation Items",
                            "type": "Array",
                            "localized": false,
                            "required": false,
                            "validations": [],
                            "disabled": false,
                            "omitted": false,
                            "items": {
                                "type": "Link",
                                "validations": [
                                    {
                                        "linkContentType": [
                                            "navigationItem"
                                        ]
                                    }
                                ],
                                "linkType": "Entry"
                            }
                        },
                        {
                            "id": "url",
                            "name": "Url",
                            "type": "Symbol",
                            "localized": false,
                            "required": false,
                            "validations": [],
                            "disabled": false,
                            "omitted": false
                        },
                        {
                            "id": "region",
                            "name": "Region",
                            "type": "Link",
                            "localized": false,
                            "required": true,
                            "validations": [
                                {
                                    "linkContentType": [
                                        "region"
                                    ]
                                }
                            ],
                            "disabled": false,
                            "omitted": false,
                            "linkType": "Entry"
                        },
                        {
                            "id": "type",
                            "name": "Type",
                            "type": "Array",
                            "localized": false,
                            "required": false,
                            "validations": [],
                            "disabled": false,
                            "omitted": false,
                            "items": {
                                "type": "Symbol",
                                "validations": [
                                    {
                                        "in": [
                                            "page",
                                            "link",
                                            "search",
                                            "file"
                                        ]
                                    }
                                ]
                            }
                        },
                        {
                            "id": "file",
                            "name": "File",
                            "type": "Link",
                            "localized": false,
                            "required": false,
                            "validations": [],
                            "disabled": false,
                            "omitted": false,
                            "linkType": "Asset"
                        }
                    ]
                },
                {
                    "sys": {
                        "space": {
                            "sys": {
                                "type": "Link",
                                "linkType": "Space",
                                "id": "erjaey3bjggb"
                            }
                        },
                        "id": "page",
                        "type": "ContentType",
                        "createdAt": "2016-11-28T19:35:33.382Z",
                        "updatedAt": "2017-10-19T06:12:38.193Z",
                        "createdBy": {
                            "sys": {
                                "type": "Link",
                                "linkType": "User",
                                "id": "603S8UAs0eYqI5l8euNs93"
                            }
                        },
                        "updatedBy": {
                            "sys": {
                                "type": "Link",
                                "linkType": "User",
                                "id": "603S8UAs0eYqI5l8euNs93"
                            }
                        },
                        "publishedCounter": 14,
                        "version": 29,
                        "publishedBy": {
                            "sys": {
                                "type": "Link",
                                "linkType": "User",
                                "id": "603S8UAs0eYqI5l8euNs93"
                            }
                        },
                        "publishedVersion": 28,
                        "firstPublishedAt": "2016-11-28T19:35:33.876Z",
                        "publishedAt": "2017-10-19T06:12:38.193Z"
                    },
                    "displayField": "title",
                    "name": "Page",
                    "description": "",
                    "fields": [
                        {
                            "id": "title",
                            "name": "Title",
                            "type": "Symbol",
                            "localized": false,
                            "required": false,
                            "validations": [],
                            "disabled": false,
                            "omitted": false
                        },
                        {
                            "id": "navigationItem",
                            "name": "Navigation Item",
                            "type": "Link",
                            "localized": false,
                            "required": false,
                            "validations": [
                                {
                                    "linkContentType": [
                                        "navigationItem"
                                    ]
                                }
                            ],
                            "disabled": false,
                            "omitted": false,
                            "linkType": "Entry"
                        },
                        {
                            "id": "backgroundImage",
                            "name": "Background image",
                            "type": "Link",
                            "localized": false,
                            "required": false,
                            "validations": [
                                {
                                    "linkMimetypeGroup": [
                                        "image"
                                    ]
                                }
                            ],
                            "disabled": false,
                            "omitted": false,
                            "linkType": "Asset"
                        },
                        {
                            "id": "articles",
                            "name": "Articles",
                            "type": "Array",
                            "localized": false,
                            "required": false,
                            "validations": [],
                            "disabled": false,
                            "omitted": false,
                            "items": {
                                "type": "Link",
                                "validations": [
                                    {
                                        "linkContentType": [
                                            "article"
                                        ]
                                    }
                                ],
                                "linkType": "Entry"
                            }
                        },
                        {
                            "id": "region",
                            "name": "Region",
                            "type": "Link",
                            "localized": false,
                            "required": true,
                            "validations": [
                                {
                                    "linkContentType": [
                                        "region"
                                    ]
                                }
                            ],
                            "disabled": false,
                            "omitted": false,
                            "linkType": "Entry"
                        }
                    ]
                },
                {
                    "sys": {
                        "space": {
                            "sys": {
                                "type": "Link",
                                "linkType": "Space",
                                "id": "erjaey3bjggb"
                            }
                        },
                        "id": "region",
                        "type": "ContentType",
                        "createdAt": "2017-09-01T13:19:23.794Z",
                        "updatedAt": "2017-09-01T13:22:53.985Z",
                        "createdBy": {
                            "sys": {
                                "type": "Link",
                                "linkType": "User",
                                "id": "603S8UAs0eYqI5l8euNs93"
                            }
                        },
                        "updatedBy": {
                            "sys": {
                                "type": "Link",
                                "linkType": "User",
                                "id": "603S8UAs0eYqI5l8euNs93"
                            }
                        },
                        "publishedCounter": 2,
                        "version": 4,
                        "publishedBy": {
                            "sys": {
                                "type": "Link",
                                "linkType": "User",
                                "id": "603S8UAs0eYqI5l8euNs93"
                            }
                        },
                        "publishedVersion": 3,
                        "firstPublishedAt": "2017-09-01T13:19:24.085Z",
                        "publishedAt": "2017-09-01T13:22:53.985Z"
                    },
                    "displayField": "title",
                    "name": "Region",
                    "description": "",
                    "fields": [
                        {
                            "id": "title",
                            "name": "Title",
                            "type": "Symbol",
                            "localized": false,
                            "required": true,
                            "validations": [],
                            "disabled": false,
                            "omitted": false
                        },
                        {
                            "id": "path",
                            "name": "Path",
                            "type": "Symbol",
                            "localized": false,
                            "required": true,
                            "validations": [
                                {
                                    "regexp": {
                                        "pattern": "\\/([a-z])*",
                                        "flags": null
                                    },
                                    "message": "Must be lowercase letters only"
                                }
                            ],
                            "disabled": false,
                            "omitted": false
                        }
                    ]
                },
                {
                    "sys": {
                        "space": {
                            "sys": {
                                "type": "Link",
                                "linkType": "Space",
                                "id": "erjaey3bjggb"
                            }
                        },
                        "id": "shopProduct",
                        "type": "ContentType",
                        "createdAt": "2017-10-19T06:30:50.098Z",
                        "updatedAt": "2017-11-09T13:55:36.886Z",
                        "createdBy": {
                            "sys": {
                                "type": "Link",
                                "linkType": "User",
                                "id": "603S8UAs0eYqI5l8euNs93"
                            }
                        },
                        "updatedBy": {
                            "sys": {
                                "type": "Link",
                                "linkType": "User",
                                "id": "603S8UAs0eYqI5l8euNs93"
                            }
                        },
                        "publishedCounter": 7,
                        "version": 14,
                        "publishedBy": {
                            "sys": {
                                "type": "Link",
                                "linkType": "User",
                                "id": "603S8UAs0eYqI5l8euNs93"
                            }
                        },
                        "publishedVersion": 13,
                        "firstPublishedAt": "2017-10-19T06:30:50.420Z",
                        "publishedAt": "2017-11-09T13:55:36.886Z"
                    },
                    "displayField": "title",
                    "name": "Shop Product",
                    "description": "People can buy marketing material, clothes and general football assessories via the website.",
                    "fields": [
                        {
                            "id": "title",
                            "name": "Title",
                            "type": "Symbol",
                            "localized": false,
                            "required": true,
                            "validations": [],
                            "disabled": false,
                            "omitted": false
                        },
                        {
                            "id": "description",
                            "name": "Description",
                            "type": "Text",
                            "localized": false,
                            "required": false,
                            "validations": [],
                            "disabled": false,
                            "omitted": false
                        },
                        {
                            "id": "priceNet",
                            "name": "Price Net",
                            "type": "Number",
                            "localized": false,
                            "required": true,
                            "validations": [],
                            "disabled": false,
                            "omitted": false
                        },
                        {
                            "id": "vat",
                            "name": "VAT",
                            "type": "Number",
                            "localized": false,
                            "required": true,
                            "validations": [
                                {
                                    "in": [
                                        0,
                                        0.09,
                                        0.17
                                    ],
                                    "message": "Must be 0, 0.09 or 0.17"
                                }
                            ],
                            "disabled": false,
                            "omitted": false
                        },
                        {
                            "id": "available",
                            "name": "Available",
                            "type": "Boolean",
                            "localized": false,
                            "required": true,
                            "validations": [],
                            "disabled": false,
                            "omitted": false
                        },
                        {
                            "id": "deliveryFee",
                            "name": "Delivery Fee",
                            "type": "Number",
                            "localized": false,
                            "required": false,
                            "validations": [],
                            "disabled": false,
                            "omitted": false
                        },
                        {
                            "id": "image",
                            "name": "Image",
                            "type": "Link",
                            "localized": false,
                            "required": false,
                            "validations": [
                                {
                                    "linkMimetypeGroup": [
                                        "image"
                                    ]
                                }
                            ],
                            "disabled": false,
                            "omitted": false,
                            "linkType": "Asset"
                        },
                        {
                            "id": "type",
                            "name": "Type",
                            "type": "Symbol",
                            "localized": false,
                            "required": false,
                            "validations": [
                                {
                                    "in": [
                                        "Formulare",
                                        "Bücher",
                                        "Bekleidung",
                                        "Merchandise",
                                        "Spielfeldmarkierung",
                                        "Schiedsrichter Shop",
                                        "Bälle",
                                        "Training"
                                    ]
                                }
                            ],
                            "disabled": false,
                            "omitted": false
                        },
                        {
                            "id": "variants",
                            "name": "Variants",
                            "type": "Array",
                            "localized": false,
                            "required": false,
                            "validations": [],
                            "disabled": false,
                            "omitted": false,
                            "items": {
                                "type": "Symbol",
                                "validations": []
                            }
                        }
                    ]
                },
                {
                    "sys": {
                        "space": {
                            "sys": {
                                "type": "Link",
                                "linkType": "Space",
                                "id": "erjaey3bjggb"
                            }
                        },
                        "id": "tournament",
                        "type": "ContentType",
                        "createdAt": "2017-10-25T13:38:52.617Z",
                        "updatedAt": "2017-11-17T12:02:25.405Z",
                        "createdBy": {
                            "sys": {
                                "type": "Link",
                                "linkType": "User",
                                "id": "603S8UAs0eYqI5l8euNs93"
                            }
                        },
                        "updatedBy": {
                            "sys": {
                                "type": "Link",
                                "linkType": "User",
                                "id": "603S8UAs0eYqI5l8euNs93"
                            }
                        },
                        "publishedCounter": 5,
                        "version": 10,
                        "publishedBy": {
                            "sys": {
                                "type": "Link",
                                "linkType": "User",
                                "id": "603S8UAs0eYqI5l8euNs93"
                            }
                        },
                        "publishedVersion": 9,
                        "firstPublishedAt": "2017-10-25T13:38:53.123Z",
                        "publishedAt": "2017-11-17T12:02:25.405Z"
                    },
                    "displayField": "title",
                    "name": "Tournament",
                    "description": "",
                    "fields": [
                        {
                            "id": "title",
                            "name": "Title",
                            "type": "Symbol",
                            "localized": false,
                            "required": true,
                            "validations": [],
                            "disabled": false,
                            "omitted": false
                        },
                        {
                            "id": "start",
                            "name": "Start",
                            "type": "Date",
                            "localized": false,
                            "required": true,
                            "validations": [],
                            "disabled": false,
                            "omitted": false
                        },
                        {
                            "id": "end",
                            "name": "End",
                            "type": "Date",
                            "localized": false,
                            "required": true,
                            "validations": [],
                            "disabled": false,
                            "omitted": false
                        },
                        {
                            "id": "registrationDeadline",
                            "name": "Registration Deadline",
                            "type": "Date",
                            "localized": false,
                            "required": true,
                            "validations": [],
                            "disabled": false,
                            "omitted": false
                        },
                        {
                            "id": "birthyears",
                            "name": "Birthyears",
                            "type": "Array",
                            "localized": false,
                            "required": false,
                            "validations": [],
                            "disabled": false,
                            "omitted": false,
                            "items": {
                                "type": "Symbol",
                                "validations": []
                            }
                        },
                        {
                            "id": "contact",
                            "name": "Contact",
                            "type": "Symbol",
                            "localized": false,
                            "required": false,
                            "validations": [],
                            "disabled": false,
                            "omitted": false
                        },
                        {
                            "id": "description",
                            "name": "Description",
                            "type": "Text",
                            "localized": false,
                            "required": false,
                            "validations": [],
                            "disabled": false,
                            "omitted": false
                        }
                    ]
                },
                {
                    "sys": {
                        "space": {
                            "sys": {
                                "type": "Link",
                                "linkType": "Space",
                                "id": "erjaey3bjggb"
                            }
                        },
                        "id": "trainer",
                        "type": "ContentType",
                        "createdAt": "2017-10-25T13:45:30.733Z",
                        "updatedAt": "2017-11-16T14:24:37.957Z",
                        "createdBy": {
                            "sys": {
                                "type": "Link",
                                "linkType": "User",
                                "id": "603S8UAs0eYqI5l8euNs93"
                            }
                        },
                        "updatedBy": {
                            "sys": {
                                "type": "Link",
                                "linkType": "User",
                                "id": "603S8UAs0eYqI5l8euNs93"
                            }
                        },
                        "publishedCounter": 4,
                        "version": 8,
                        "publishedBy": {
                            "sys": {
                                "type": "Link",
                                "linkType": "User",
                                "id": "603S8UAs0eYqI5l8euNs93"
                            }
                        },
                        "publishedVersion": 7,
                        "firstPublishedAt": "2017-10-25T13:45:31.090Z",
                        "publishedAt": "2017-11-16T14:24:37.957Z"
                    },
                    "displayField": "name",
                    "name": "Trainer",
                    "description": "",
                    "fields": [
                        {
                            "id": "name",
                            "name": "Name",
                            "type": "Symbol",
                            "localized": false,
                            "required": true,
                            "validations": [],
                            "disabled": false,
                            "omitted": false
                        },
                        {
                            "id": "birthdate",
                            "name": "Birthdate",
                            "type": "Date",
                            "localized": false,
                            "required": true,
                            "validations": [],
                            "disabled": false,
                            "omitted": false
                        },
                        {
                            "id": "address",
                            "name": "Address",
                            "type": "Symbol",
                            "localized": false,
                            "required": true,
                            "validations": [],
                            "disabled": false,
                            "omitted": false
                        },
                        {
                            "id": "phone",
                            "name": "Phone",
                            "type": "Symbol",
                            "localized": false,
                            "required": true,
                            "validations": [],
                            "disabled": false,
                            "omitted": false
                        },
                        {
                            "id": "email",
                            "name": "Email",
                            "type": "Symbol",
                            "localized": false,
                            "required": true,
                            "validations": [
                                {
                                    "regexp": {
                                        "pattern": "^\\w[\\w.-]*@([\\w-]+\\.)+[\\w-]+$"
                                    }
                                }
                            ],
                            "disabled": false,
                            "omitted": false
                        },
                        {
                            "id": "licence",
                            "name": "Licence",
                            "type": "Symbol",
                            "localized": false,
                            "required": true,
                            "validations": [],
                            "disabled": false,
                            "omitted": false
                        },
                        {
                            "id": "lastTraining",
                            "name": "Last training",
                            "type": "Symbol",
                            "localized": false,
                            "required": true,
                            "validations": [],
                            "disabled": false,
                            "omitted": false
                        },
                        {
                            "id": "comment",
                            "name": "Comment",
                            "type": "Text",
                            "localized": false,
                            "required": false,
                            "validations": [],
                            "disabled": false,
                            "omitted": false
                        }
                    ]
                },
                {
                    "name": "Poll",
                    "description": "Multiple choice questions for the homepage",
                    "displayField": "question",
                    "fields": [
                        {
                            "id": "question",
                            "name": "Question",
                            "type": "Symbol",
                            "localized": false,
                            "required": true,
                            "validations": [],
                            "disabled": false,
                            "omitted": false
                        },
                        {
                            "id": "options",
                            "name": "Options",
                            "type": "Array",
                            "localized": false,
                            "required": false,
                            "validations": [],
                            "disabled": false,
                            "omitted": false,
                            "items": {
                                "type": "Symbol",
                                "validations": []
                            }
                        }
                    ],
                    "sys": {
                        "space": {
                            "sys": {
                                "type": "Link",
                                "linkType": "Space",
                                "id": "erjaey3bjggb"
                            }
                        },
                        "id": "poll",
                        "type": "ContentType",
                        "createdAt": "2018-04-15T06:51:57.835Z",
                        "updatedAt": "2018-04-15T06:51:58.199Z",
                        "environment": {
                            "sys": {
                                "id": "master",
                                "type": "Link",
                                "linkType": "Environment"
                            }
                        },
                        "createdBy": {
                            "sys": {
                                "type": "Link",
                                "linkType": "User",
                                "id": "603S8UAs0eYqI5l8euNs93"
                            }
                        },
                        "updatedBy": {
                            "sys": {
                                "type": "Link",
                                "linkType": "User",
                                "id": "603S8UAs0eYqI5l8euNs93"
                            }
                        },
                        "publishedCounter": 1,
                        "version": 2,
                        "publishedBy": {
                            "sys": {
                                "type": "Link",
                                "linkType": "User",
                                "id": "603S8UAs0eYqI5l8euNs93"
                            }
                        },
                        "publishedVersion": 1,
                        "firstPublishedAt": "2018-04-15T06:51:58.199Z",
                        "publishedAt": "2018-04-15T06:51:58.199Z"
                    }
                }

            ];

            contentTypes.forEach(contentType => {
                contentType.fields.forEach(field => {
                    let validations = {
                        required: {
                            value: field.required,
                            message: 'Required'
                        }
                    };

                    field.validations.forEach(validation => {
                        if (validation.size) {
                            if (validation.size.min) {
                                validations.minlength = {
                                    value: validation.size.min,
                                    message: validation.message
                                };
                            }

                            if (validation.size.max) {
                                validations.maxlength = {
                                    value: validation.size.max,
                                    message: validation.message
                                };
                            }
                        } else if (validation.range) {
                            if (_.isNumber(validation.range.min)) {
                                validations.min = {
                                    value: validation.range.min,
                                    message: validation.message
                                };
                            }

                            if (_.isNumber(validation.range.max)) {
                                validations.max = {
                                    value: validation.range.max,
                                    message: validation.message
                                };
                            }
                        } else if (validation.regexp) {
                            validations.pattern = {
                                value: validation.regexp.pattern,
                                message: validation.message
                            };
                        } else if (validation.in) {
                            validations.in = validation;
                        }
                    });

                    field.validations = validations;
                });
            });

            $window.contentfulCustomCmsAppData = {
                contentTypes
            };

            let Raven = require('raven-js');
            Raven
                .config('https://377a4700049645629976c75977633d01@sentry.io/261466')
                .addPlugin(require('raven-js/plugins/angular'), angular)
                .install();

            $window.raven = Raven;

            // hide loader
            Loader.hide();

            // run app
            angular.bootstrap(document, [app], { strictDi: true });

            /*console.log('bootstrapapp - url', url);
            $http.get(url, config).then((data) => {

                console.log('Data Context Type', data.data);

                let contentTypes = data.data.items;

                contentTypes.forEach(contentType => {
                    contentType.fields.forEach(field => {
                        let validations = {
                            required: {
                                value: field.required,
                                message: 'Required'
                            }
                        };

                        field.validations.forEach(validation => {
                            if (validation.size) {
                                if (validation.size.min) {
                                    validations.minlength = {
                                        value: validation.size.min,
                                        message: validation.message
                                    };
                                }

                                if (validation.size.max) {
                                    validations.maxlength = {
                                        value: validation.size.max,
                                        message: validation.message
                                    };
                                }
                            } else if (validation.range) {
                                if (_.isNumber(validation.range.min)) {
                                    validations.min = {
                                        value: validation.range.min,
                                        message: validation.message
                                    };
                                }

                                if (_.isNumber(validation.range.max)) {
                                    validations.max = {
                                        value: validation.range.max,
                                        message: validation.message
                                    };
                                }
                            } else if (validation.regexp) {
                                validations.pattern = {
                                    value: validation.regexp.pattern,
                                    message: validation.message
                                };
                            } else if (validation.in) {
                                validations.in = validation;
                            }
                        });

                        field.validations = validations;
                    });
                });

                $window.contentfulCustomCmsAppData = {
                    contentTypes
                };

                // hide loader
                Loader.hide();

                // run app
                angular.bootstrap(document, [app], { strictDi: true });
            }, (error) => {});
            */
        }


        injector.invoke(['$http', '$window', ($http, $window) => {
            let host = window.location.host.split('.')[0];

            let configFirebase = {
                apiKey: "AIzaSyBYhlqdcQpIqLargbODZmqnisgLQrmpXVc",
                authDomain: "wfv-cms.firebaseapp.com",
                databaseURL: "https://wfv-cms.firebaseio.com",
                projectId: "wfv-cms",
                storageBucket: "wfv-cms.appspot.com",
                messagingSenderId: "141416234892"
            };

            let path = 'https://bw-football-contentful.appspot.com/';


            if (host.indexOf('localhost') >= 0 || host.indexOf('develop') >= 0) {
                configFirebase = {
                    apiKey: "AIzaSyCx_6aQm5xhXHiAhFdrmaefw4mFpQlLS60",
                    authDomain: "wfv-cms-develop.firebaseapp.com",
                    databaseURL: "https://wfv-cms-develop.firebaseio.com",
                    projectId: "wfv-cms-develop",
                    storageBucket: "wfv-cms-develop.appspot.com",
                    messagingSenderId: "6981202812"
                };

                path = 'https://bw-football-contentful-dev.appspot.com/';
            }

            let fakeProduction = getCookie('enableProduction');

            if (!!fakeProduction && fakeProduction) {
                configFirebase = {
                    apiKey: "AIzaSyBYhlqdcQpIqLargbODZmqnisgLQrmpXVc",
                    authDomain: "wfv-cms.firebaseapp.com",
                    databaseURL: "https://wfv-cms.firebaseio.com",
                    projectId: "wfv-cms",
                    storageBucket: "wfv-cms.appspot.com",
                    messagingSenderId: "141416234892"
                };
            }

            url = `${path}`;
            firebase.initializeApp(configFirebase);

            let accessToken = getCookie('accessToken');
            let token = getCookie('token');

            setCookie('regions', '');
            setCookie('region', '');

            console.log(token, accessToken);
            if (!!accessToken) {
                boostrapApp($http, $window);
            } else {
                if (!!token) {
                    let config = {
                        headers: {
                            'X-Auth-Token': getCookie('token')
                        }
                    };

                    $http.get(`${url}manage/contentful/access_token`, config).then((data)=> {
                        setCookie('accessToken', data.data.accessToken);
                        boostrapApp($http, $window);
                    }, (e) => {
                        boostrapApp($http, $window);
                    });
                } else {
                    boostrapApp($http, $window);
                }
            }
        }]);
    });
}

// bootstrap application
window.addEventListener('load', () => {
    if (!Incompatible.isIncompatibleBrowser()) {
        // show loader
        Loader.render(loaderTemplate, loaderStyle, { loader: copy.loader.start });
        Loader.show();

        // start loader
        Loader.createLoader('main', _progress, _complete);
    }
});





// WEBPACK FOOTER //
// ./src/entry/main.js